import Box from '@totallymoney/ui/components/Box'
import Flex from '@totallymoney/ui/components/Flex'
import Grid from '@totallymoney/ui/components/Grid'

import { CategoryComparatorKey } from '@routes/ScoredTableRoute/components/ScoredTable/utils/categorySortKeyComparatorKeys'

import FilterButton from './components/FilterButton'
import MinimumCreditLimitUpdate from './components/MinimumCreditLimitUpdate'
import SortButton from './components/SortButton'

interface ScoredTableHeaderProps {
    isActivatedFilter: boolean
    isActivatedSort: boolean
    onShowCategoryFilterModal: () => void
    onShowMinimumCreditLimitModal: () => void
    onShowSortByModal: () => void
    selectedSortKey: CategoryComparatorKey
}

const ScoredTableHeader = ({
    isActivatedFilter,
    isActivatedSort,
    onShowCategoryFilterModal,
    onShowMinimumCreditLimitModal,
    onShowSortByModal,
    selectedSortKey,
}: ScoredTableHeaderProps) => {
    return (
        <Grid>
            <Box gridColumn={['1/9']} mt={['space20', 'space30']}>
                <MinimumCreditLimitUpdate
                    onShowMinimumCreditLimitModal={
                        onShowMinimumCreditLimitModal
                    }
                />
            </Box>
            <Flex gridColumn={['12/13']} mt={['space20', 'space30']}>
                <Box mr="space10">
                    <SortButton
                        isActivated={isActivatedSort}
                        onClick={onShowSortByModal}
                        selectedSortKey={selectedSortKey}
                    />
                </Box>
                <FilterButton
                    isActivated={isActivatedFilter}
                    onClick={onShowCategoryFilterModal}
                />
            </Flex>
        </Grid>
    )
}

export default ScoredTableHeader
